export default __webpack_public_path__ + "static/media/verified-barcode.980e298a.svg";